// src/components/modules/entertainment.js

import React, { useState } from 'react';
import {   
  BrowserView,
  MobileView,
  isBrowser,
  isMobile } 
  from 'react-device-detect';

const Entertainment = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  
  
  
  const handleLinkClick = (event, appName, browserURL, appURL) => {
    event.preventDefault();
    const userAgent = navigator.userAgent;
    if (isMobile && userAgent.includes(appName)) {
      window.location.href = appURL;
      console.log(appName + " is installed!");
    } else {
      window.open(browserURL, '_blank');
      console.log(appName + " is NOT installed!");
    }
  }
  
  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Entertainment' : 'Entertainment'}
      </button>
      {isExpanded && (
        <ul>
          <ul><a href="nflx://www.netflix.com">Netflix Test</a></ul>
          <li><a translate="no" href="#" onClick={(event) => handleLinkClick(event, "youtube", "https://www.youtube.com", "youtube://")} rel="noopener noreferrer">YouTube</a></li>
          <li><a translate="no" href="#" onClick={(event) => handleLinkClick(event, "Netflix", "https://www.netflix.com", "nflx://")} rel="noopener noreferrer">Netflix</a></li>
          <li><a translate="no" href="#" onClick={(event) => handleLinkClick(event, "com.spotify.mobile.android.ui", "https://open.spotify.com", "spotify://")} rel="noopener noreferrer">Spotify</a></li>
          <li><a translate="no" href="https://www.imdb.com" target="_blank" rel="noopener noreferrer">IMDB</a></li>
          <li><a translate="no" href="https://www.ign.com" target="_blank" rel="noopener noreferrer">IGN</a></li>
          <li><a translate="no" href="https://www.vulture.com" target="_blank" rel="noopener noreferrer">Vulture</a></li>
          <li><a translate="no" href="https://www.reddit.com" target="_blank" rel="noopener noreferrer">Reddit</a></li>
        </ul>
      )}
    </div>
  );
}

export default Entertainment;